import React from "react";

function Wong() {
  return (
    <div className="content-container resources-page">
      <h1>Wong Jack Man Interview - 2017</h1>

      <quote>By Michael Dorgan - Date: August 5, 2017</quote>

      <p>
        The story behind the story: Shaolin Grandmaster Wong Jack Man talks with
        Michael Dorgan about “Birth of the Dragon” and his epic fight with Bruce
        Lee that inspired the film.
      </p>

      <p>
        <b>Michael Dorgan:</b> What did you think of “Birth of the Dragon?”
      </p>
      <p>
        <b>Wong Jack Man:</b> I found the movie entertaining, a fun film to see
        with your family and friends. It has lots of action and comedy, and also
        offers a lesson to be learned. It's about two martial artists who
        followed very different paths, one becoming the world famous movie star
        and the other a kung fu grandmaster of Northern Shaolin, Taijiquan and
        Hsingyiquan. I will tell my friends to see it because it will bring back
        many fond memories of their youth, when kung fu was very popular.
      </p>
      <p>
        <b>Michael Dorgan:</b> What did you think of the actors' portrayals of
        you and Bruce Lee?
      </p>
      <p>
        <b>Wong Jack Man:</b> Xia Yu, who is a very famous actor in China, was
        excellent in portraying me. He was able to capture the essence of my
        reserved nature and my exceptional martial arts skills. He does not have
        a martial arts background but he is very athletic and convincing on
        film. Philip Ng, who portrayed Bruce, was also excellent. He resembles
        Bruce and has his body type. And he conveyed Bruce's charisma and
        cockiness, as well as his accent and mannerisms. Also, he had the
        martial arts skills to play the part. He is known for his stunts and
        choreography in Hong Kong film. I see a future for him as an actor.
      </p>
      <p>
        <b>Michael Dorgan:</b> Did you like the fight scenes?
      </p>
      <p>
        <b>Wong Jack Man:</b> Yes, they were very exciting to watch. I think
        they kept everyone at the edge of their seats.
      </p>
      <p>
        <b>Michael Dorgan:</b> What were some of your favorite parts?
      </p>
      <p>
        <b>Wong Jack Man:</b> My favorite part was when I head locked Bruce,
        which actually happened three times during our fight in 1964. I also
        liked it when Bruce and I team up to fight the gangsters. It was very
        funny, with non-stop action. I heard it took two weeks just to film the
        fight between Bruce and me and our final fight with the gangsters. It
        took a lot of skills from the actors, stunt people, stunt choreographers
        and the talented director to pull it off.
      </p>
      <p>
        <b>Michael Dorgan:</b> What do you think of the Steve character in the
        movie and the criticism some have made of making him a major character
        in a film about you and Bruce Lee?
      </p>
      <p>
        <b>Wong Jack Man:</b> That was not a problem for me. He was the narrator
        who was driving and telling the story of me and Bruce. Who else could
        have told the story? Besides, he played as Bruce Lee's white student –
        are they now saying Bruce Lee could not teach a white student? According
        to Linda Lee, the whole reason for the fight between Bruce and me was so
        Bruce could teach kung fu to the white man and others of a difference
        race. I really don't understand all this nonsense. They created a little
        side story about the character Steve to make him a bit more interesting
        and to help set up the fight between my character and Bruce Lee and the
        fight the two of us had with the gangsters. This film is made for the
        international market - it should have an international cast. Most of the
        criticism is from some Bruce Lee fans and his daughter, Shannon. They
        don't understand that this film is not a biopic about Bruce Lee but was
        inspired by the fight and is highly stylized and fictionalized. Bruce
        Lee was portrayed as he was in his early twenties. Are they just going
        to ignore that part of his history? He later matured and moved on to
        become world famous and put martial arts on the map. Bruce Lee's films
        were fictionalized, too, so I don't see a problem with it.
      </p>
      <p>
        <b>Michael Dorgan:</b> You and Bruce Lee both grew up in Hong Kong and
        were about the same age. Did you ever meet him there, or had you heard
        of him?
      </p>
      <p>
        <b>Wong Jack Man:</b> Bruce Lee was a year older than me. He was born on
        November 27, 1940, and I was born on December 1, 1941. I never met him
        or heard of him while I was in Hong Kong.
      </p>
      <p>
        <b>Michael Dorgan:</b> What was your childhood like and how did you
        become involved in Kung Fu?
      </p>
      <p>
        <b>Wong Jack Man:</b> My childhood was pretty normal. Like most boys my
        age, I became interested in martial arts by watching martial arts
        movies, reading martial arts stories and martial arts comic books, and
        watching street performers.
      </p>
      <p>
        <b>Michael Dorgan:</b> What made you decide to immigrate to America and
        what did you hope to achieve here?
      </p>
      <p>
        <b>Wong Jack Man:</b> I came to America to be united with my family. And
        I was asked by my teachers, Yim Sheung Mo and Ma Kin Fung, to spread the
        Northern Shaolin, Taijiquan and Xingyiquan to America and the world. My
        teachers were top students of the famed master Gu Ruzhang, widely known
        as Iron Palm because of his ability to smash even large stacks of bricks
        with his bare hand, and they were members of the non- governmental Jing
        Wu martial arts organization, whose motto is “Love your country,
        cultivate your character and be a good citizen of the community.” It is
        all about doing the right things and showing great concern for morals
        and ethics. Jing Wu has promoted martial arts training for men, women
        and children to build strong bodies and healthy minds since it was
        founded in 1909 in Old China. Fifty-nine branches of Jing Wu have sprung
        up in 22 countries since I first brought Northern Shaolin to America in
        the early 1960's.
      </p>
      <p>
        <b>Michael Dorgan:</b> Tell us about the San Francisco Chinatown martial
        arts scene in the early 1960&#39;s, when some schools were aligned
        “tong” organizations, the fraternal and social groups that sometimes ran
        gambling, prostitution and racketeering operations.
      </p>
      <p>
        <b>Wong Jack Man:</b> When I first arrived in San Francisco, I taught at
        a social club for what you might call the “big shots” of Chinatown, who
        were interested in Taijiquan and other traditional Chinese martial arts.
        They were impressed by my skills, which they had seen at my
        demonstrations at various community locations, and I was asked to join
        the club by member Lau Yee Sing, the owner of the Great Eastern Café,
        who had a passion for martial arts. I worked part-time at his restaurant
        as a waiter to make ends meet until I became a full-time instructor,
        teaching all day and into the evenings. San Francisco Chinatown in the
        1960's had a booming night life. There were six Chinese movie theaters
        packed every night showing martial arts movies, historical dramas and
        comedies. The restaurants were always filled with families and friends
        having late dinners or snacks after a night out to the movies. It was
        the best of times being in the middle of it. There were only two martial
        arts teachers who were members of a tong. One was Wong Tim Yuen, a.k.a.
        T.Y. Wong, of the “Sturdy Citizen's Club". He was a member of The Hop
        Sing Tong and taught a southern style of kung fu. The other
        tong-connected teacher was Lau Bun, chief instructor of the Hop Sing
        Tong Kung Fu Club, who taught the southern style Choy Li Fut. He taught
        private groups and tong members, and later renamed his school Hung Sing
        Studio. He also taught Lion Dancing. These two teachers were well
        respected and taught their students to be good citizens of the
        community. They were also “enforcers” for the community against
        troublemakers. The tongs were first established as places for the single
        men to go for help in finding housing and jobs, and in acclimating to a
        new country. They were able to share their roots and language, and were
        given a sense of belonging and community. Only a small number of tong
        members were involved in criminal activities at the time. Before I
        arrived in San Francisco in the early 1960's, there were only a few
        traditional Chinese martial arts teachers and kung fu was not yet
        popular. All the young people, including the Asian kids, were learning
        Karate, the Japanese martial art system bought back by the serviceman
        after World War II. There were Karate schools everywhere, even in
        Chinatown. I was the new kid in town. I brought something new to the
        martial arts community through my performances and demonstrations by my
        students at schools and auditoriums. I was the only one doing these
        public shows. Later, other kung fu instructors and I organized the
        National Chinese Gungfu Exhibition at the San Francisco Civic Center to
        showcase various styles of Kung Fu. We invited Bruce Lee to participate
        but he declined. We later found out he came up from Los Angeles to watch
        it in a disguise. I did not see him but others recognized him and told
        me. I also gave solo performances at Chinese Family Association
        gatherings and participated in many Chinese New Year celebrations
        locally and outside of Chinatown. People were impressed because they
        never seen the Northern Shaolin system, which is both powerful and
        acrobatic. It includes high kicks, big leaps, aggressive long-range
        attacks and whirling, circular blocks. It also features traditional
        Chinese weapons, including staff, spear, straight sword, double
        butterfly swords, double tiger hooked swords, saber, chain whips,
        three-section staff and guan dao. Ming Lum, a local martial arts
        promoter, began taking my students to Karate tournaments, where they
        were often winners. That made people take notice. Soon, my reputation
        grew and I was teaching Karate Instructors and instructors of other
        popular martial arts. Once Karate Instructors and other types of martial
        artists learned from me, they changed their business signs to announce
        they were also teaching kung fu. It was the golden era of kung fu, and
        pretty soon everyone with a little knowledge was teaching it. By the
        early 1970s, kung fu became even more widely popularized by Bruce Lee
        through his films and by the “Kung Fu” television series starring David
        Carradine. The stunt coordinator for that TV series was also a student
        of mine. I never advertised my schools in the newspapers. My business
        grew by word of mouth of my reputation and from my involvement in my
        community and outside communities. I had a martial artist move here from
        Hawaii to learn my Northern Shaolin system and then move on to win many
        championships and become known as the “Godfather of Kung Fu in Europe.”
        His wife also studied with me and became the top-ranked women fighter in
        the United States. She also fought men and won. I also trained the first
        non-Asian full-contact fighter to ever win a gold medal at the World
        Championship full-contact Chinese Martial Arts Tournament in Taiwan.
      </p>
      <p>
        <b>Michael Dorgan:</b> Bruce Lee's wife, Linda, wrote that you
        challenged him on behalf of the Chinatown kung fu teachers, who were
        angry that he was teaching Caucasians. Is it true? If not, what provoked
        the fight?
      </p>
      <p>
        <b>Wong Jack Man:</b> What she wrote is absolutely not true. What
        provoked the fight was Bruce Lee's arrogance and his insulting treatment
        of other martial artists. He trashed the teachers in Chinatown, calling
        them "old tigers with no teeth" and lectured them about his Wing Chun
        system being far superior to their traditional Chinese martial arts. The
        matter came to a head following a performance he gave at the Sun Sing
        Theater with Hong Kong actress Diana Chang, who was regarded as the
        Marilyn Monroe of Asia and was there to promote her new movie, “Amorous
        Lotus Pan.” She did a Cha Cha dance with Bruce, who was there to promote
        his school. In front of a packed house, he demonstrated his one-inch
        punch - a punch launched just an inch from the opponent. He demonstrated
        it with his friend, George Long, who taught the White Crane system. It
        did not go well and the audience laughed and booed him. That angered
        Bruce. He tried again and succeeded in knocking George backwards, but
        George was not pleased and complained that he had not been ready for the
        second try. Bruce was still upset and issued a public challenge to
        anyone who thought he was better then him. The Chinatown martial arts
        community decided it needed to respond and that I was the best-qualified
        person to exchange skills with Bruce Lee. A letter was written and hand
        delivered to Bruce at his Oakland school inviting him to discuss what
        happened at the Sun Sing Theater and to exchange martial arts skills
        with me. He refused to come to San Francisco, but wrote a note inviting
        me to his school in Oakland with the date and time to meet.
      </p>
      <p>
        <b>Michael Dorgan:</b> Why were only a few people allowed to witness the
        fight and what were the agreed upon rules, if any?
      </p>
      <p>
        <b>Wong Jack Man:</b> It was a private exchange of skills. There was no
        discussion of rules until moments before the match.
      </p>
      <p>
        <b>Michael Dorgan:</b> Bruce Lee and his former wife both said he
        quickly defeated you. What is your account of what happened?
      </p>
      <p>
        <b>Wong Jack Man:</b> I got a ride to Bruce's school with an
        acquaintance. Four of his friends were also in the car, but I didn't
        know them. I was wearing my traditional black kung fu uniform. It was a
        deserted part of town, and we arrived at exactly 6:00 pm. His school was
        an empty storefront with no business sign. We walked in. It was a small
        room with no furnishings. One of Bruce Lee's friends made the
        introduction, as it was the first time we had met each other. I was
        introduced only to Bruce. I asked him if he had issued a challenge at
        the Sun Sing Theater. He told me no, that he had not issued a challenge
        on stage. At that point, I thought he did not really want to spar or
        exchange skills with me. Our group all started to leave but then the
        person who let us in locked the door. Bruce became very angry and
        started yelling and cursing. He told me, 'You have been killed by your
        friend', and 'He is going to ruin your life.' At that moment, I thought
        that was a strange thing for him to say. But Bruce knew that the person
        who hand-carried the letter to him had set us both up. When the letter
        was delivered, Bruce was angry and was ready to fight him. Now Bruce was
        so angry that he cursed him, and that person became very frightened and
        nervous. All the people in the room were scared, and the tension was
        high. Bruce told me he was not here to make friends and that we should
        fight to see whose skill level was higher. I think he felt he would lose
        face if he did not fight me in front of his friends and the others who
        were there. I told him we were just going to spar. I quickly laid down
        the universal standard rules in a match: no poking the eyes, no grabbing
        the throat or kicking the groin. He angrily responded, “No holds barred.
        No rules. We are going to fight to the death.” After the other people
        stepped to the side, Bruce asked me to come to the center of the room. I
        extended my hand for a handshake, as is customary in any open match.
        Bruce pretended to offer his hand but immediately curved his fingers
        like deadly claws and tried to poke out my eyes. My quick instincts
        blocked him from doing damage to my eyes, though he ended up scratching
        me with his fingernail above my eye. That attack set the tone of the
        fight. Then he started to make these loud, horrifying sounds - like a
        ghost screaming is the only way I can describe it. I never heard sounds
        like that before in my life, and they were scaring everyone in the room.
        He continued to swear, yell and utter the terrifying sounds as he
        repeatedly tried to attack my eyes, throat and groin in between throwing
        straight punches at my chest. It was these techniques he used the most,
        and I had to step backward to avoid his attacks. He was basically out of
        control and trying to do me serious harm. He chased me, arms swinging,
        but I side-stepped him each time so his blows were not effective. I also
        had to create distance so I could attack him using my long-range
        techniques to counter his attacks. At one point, I caught him as he
        charged at me and locked his head under my left arm. Both of his arms
        fell to his sides and he was shaking because of my strong grasp on him.
        I could have finished him off with my right fist or choked him out but
        did not since I feared the consequences if I seriously hurt him. After I
        let him go, he became even more enraged and continued to curse, yell and
        make god-awful sounds. I really thought he was on something at that
        point. And I thought he really wanted to kill me. He continued his
        aggressive but ineffective attacks. I ended up locking his head again
        but this time he was on his knees. I let him go again, then caught him
        again and locked his head for a third time. But he remained full of rage
        when I let him go. He continued to charge at me, swinging his fists. I
        used my windmill blocks and hit him three times in the head in rapid
        session. He staggered and spun around three times and all the sudden
        stopped yelling, cursing and making the noises. He was so winded he
        could not go on. That was how the match ended. Linda Lee later wrote
        that the fight lasted only three minutes but it actually lasted about 20
        minutes. Before we left, Bruce Lee asked me not to discuss the fight
        with anyone and I agreed. But later he bragged to people that he had
        won, which is why I then I issued a public challenge on the front page
        of a local Chinese newspaper, inviting him to fight me in an open arena
        filled with witnesses. He did not respond.
      </p>
      <p>
        <b>Michael Dorgan:</b> Bruce Lee at the time had trained only in Wing
        Chun, a southern martial arts style that emphasizes straight ahead
        attacks with fast, powerful punches. Your Northern Shaolin favors,
        longer, more circular strikes and blocks and more kicks. What did you
        learn from the fight as a martial artist? What did you learn as a man?
      </p>
      <p>
        <b>Wong Jack Man:</b> As a martial artist, I learned nothing from the
        fight or from him. He threw away his system (Wing Chun) after the fight
        because it had not worked for him, and began developing his own system,
        Jeet Kune Do, which borrowed high kicks and many other movements from my
        system and from other systems. Bruce Lee later became famous only
        because he fought with me. That fight forced him to develop a new
        fighting system and philosophy that led to his success as a martial arts
        movie star. I was progressing in the internal martial arts way before
        the fight with Bruce Lee. He had nothing to teach me. As a man, I
        learned from the fight not to trust what I hear from others. I must
        analyze and research the truth and evidence before I act on it.
      </p>
      <p>
        <b>Michael Dorgan:</b> Are you surprised by the enduring interest in the
        fight within the martial arts community? Why do you think people still
        like to discuss and debate it?
      </p>
      <p>
        <b>Wong Jack Man:</b> I think the fight has enduring interest because we
        were two well- known martial artists and it was a closed-door event and
        the witnesses could not agree on what they saw or the outcome of the
        fight. This type of event should be held in public for all to see with
        rules, judges and referees, so the end results are very clear. My fight
        with Bruce Lee has been talked about and debated for over 50 years
        around the world and it probably will be debated for another 50 years.
        Who else can claim this? Not even Ali or Frazier.
      </p>
      <p>
        <b>Michael Dorgan:</b> In China, there was a long tradition of secrecy
        surrounding martial arts, which often were taught only to men and only
        to family or clan members. You were one of the first Chinese kung fu
        teachers to open his school to men and women of all ethnicities. What
        benefits do you think martial arts offer to modern society?
      </p>
      <p>
        <b>Wong Jack Man:</b> Kung fu teaches compassion, wisdom, positive
        thinking, gentleness, patience, harmony, diligence, perseverance,
        courage, honesty, righteousness, loyalty, self-discipline and
        responsibility. It promotes inner strength, healthy habits and the
        enjoyment of life, as well as a calm, clear mind and good spirits.
        Learning self-defense skills improves self- confidence, builds a strong
        body and allows you to help others less fortune then you. In other
        words, kung fu can help develop a well-rounded individual. This is
        helpful in modern society, where many people lack the skills to have a
        successful life.
      </p>
    </div>
  );
}

export default Wong;
